export function onlyUniqueStringArray(array: string[]) {
	const filterHandler = (value: string, index: number, array: string[]) =>
		array.indexOf(value) === index;
	return array.filter(filterHandler);
}
